<script>
import { mapActions } from 'vuex'
import ChartLine from './charts/chart-line'

export default {
  name: 'DashboardClicksPerDay',
  components: { ChartLine },
  props: {
    clickTypes: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      requesting: true,
      allClicks: {},
      periods: [
        { value: 'week', label: 'Last Week' },
        { value: 'month', label: 'Last Month' },
        { value: 'year', label: 'Last Year' },
      ],
      selectedPeriod: { value: 'week', label: 'Last Week' },
    }
  },
  computed: {
    labels() {
      const result = []

      for (const offerType of Object.values(this.allClicks)) {
        for (const date of Object.keys(offerType)) {
          if (!result.includes(date)) result.push(date)
        }
      }


      return result.sort()
    },
    preparedData() {
      const availableTypes = Object.keys(this.allClicks)

      return availableTypes.map(type => {
        const details = this.clickTypes.find(t => t.name === type)
        const clicksByDay = this.allClicks[type]
        const data = this.labels.map(day => {
          return {
            day,
            clicksCount: clicksByDay[day] || 0,
          }
        })

        return {
          fill: details.fill,
          label: details.label,
          clicksByDay,
          data,
        }
      })
    },
  },
  created() {
    this.getData()
  },
  methods: {
    ...mapActions('dashboard', ['getClicks', 'getClicksNew']),
    async getData() {
      this.requesting = true
      const res = await this.getClicksNew({
        dataType: 'clicks_by_day',
        period: this.selectedPeriod.value,
      })
      this.allClicks = res
      this.requesting = false
    },
    changePeriod(period) {
      this.selectedPeriod = period
      this.getData()
    },
  },
}
</script>


<template>
  <el-card>
    <div
      slot="header"
      :class="$style.cardHeader"
    >
      Clicks per Day
      <el-dropdown
        trigger="click"
        :class="$style.cardDropdown"
      >
        <span>
          {{ selectedPeriod.label }}
          <i class="el-icon-arrow-down el-icon--right" />
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-for="(period, index) in periods"
            :key="index"
            @click.native="changePeriod(period)"
          >
            {{ period.label }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <base-loader v-if="requesting" />
    <chart-line
      v-else-if="labels.length > 0"
      :datasets="preparedData"
      :labels="labels"
      :height="250"
    />
    <div
      v-else
      :class="$style.clicksPerDayNoData"
    >
      No Data
    </div>
  </el-card>
</template>

<style lang="scss" module>
.cardHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.cardDropdown {
  color: var(--color-text-light);
  cursor: pointer;
}


.clicksPerDayNoData {
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-text-light);
  height: rem(253px);
}
</style>